import { Locale } from "@hermes/locale";

import { isQQBrowerAgent } from "../browser/browser.helper";

/**
 * Cleanup url to match angular routes.
 *
 * @param path unsanitized url
 * @return path without first slash and no hash part
 */
export const pathCleaner = (path: string): string =>
    path
        // remove first slash
        .replace(/^\//, "")
        // remove char after hashbang
        .replace(/#(.*)$/, "")
        // remove back slash
        .replace(/\/$/, "");

/**
 * Obtain url substring that match a given regExp at a given index.
 *
 * @param url url string to search in
 * @param regExp expression to match a substring
 * @param index element index to output
 * @return matching element at specified index or empty string if no match
 */
export const getMatchAtIndex = (
    url: string | undefined,
    regExp: RegExp,
    index: number,
): string => {
    const result = url?.match(regExp);

    return result?.at(index) ?? "";
};

/**
 * @returns the product link to go to the product page from grid
 */
export const generateLocalizedHref = (url: string, locale: Locale): string => {
    // all product item url must end end with a '/'
    const end = url?.endsWith("/") ? "" : "/";
    // we want the full url with base href (/xx/yy/product/*) all the time.
    return `${locale.urlPrefix}${url}${end}`;
};

export const formatAssetUrl = (url: string, userAgent?: string): string => {
    url = url.replace(/\s/g, "");
    // Some browsers (namely QQBrowser) consider `,` as an srcset
    // separator. Encoding the comma prevents that
    if (isQQBrowerAgent(userAgent)) {
        url = url.replace(/,/g, "%2C");
    }
    return url;
};
